<template>
  <div>
    <button
      type="button"
      class="btn btn-link p-0 d-inline-flex align-items-center gap-2 text-decoration-none collapsible-toggle"
      :aria-expanded="open"
      :aria-controls="bodyId"
      @click="open = !open"
    >
      <FontAwesomeIcon :icon="open ? 'chevron-down' : 'chevron-right'" />
      <span class="fw-semibold">{{ title }}</span>
      <slot name="summary" />
    </button>
    <div v-if="open" :id="bodyId" class="mt-1">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";

/**
 * A titled part of a card that starts collapsed. The `summary` slot sits beside the title, so what
 * matters about the hidden part (volume still open, say) shows without expanding it.
 */
defineProps<{
  title: string;
}>();

const bodyId = useId();
const open = ref(false);
</script>

<style scoped lang="scss">
// The theme sets buttons at 0.8rem; the toggle reads as part of the card's text.
.collapsible-toggle {
  font-size: inherit;
}
</style>
